import { render, staticRenderFns } from "./Usage-Quota.vue?vue&type=template&id=4e33c050&scoped=true&"
import script from "./Usage-Quota.vue?vue&type=script&lang=js&"
export * from "./Usage-Quota.vue?vue&type=script&lang=js&"
import style0 from "./Usage-Quota.vue?vue&type=style&index=0&id=4e33c050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e33c050",
  null
  
)

export default component.exports